import axios from ".";

export const getTermsOfService = (
  scope: "admin" | "provider" | "preneed-planner" | "public" = "admin"
) => {
  const urlByScope: Record<typeof scope, string> = {
    admin: "/admin/terms-of-service",
    provider: "/provider-dashboard/terms-of-service",
    "preneed-planner": "/planner-dashboard/terms-of-service",
    public: "/terms-of-service",
  };
  const url = urlByScope[scope];
  return axios({
    method: "GET",
    url,
  });
};


export const saveTermsOfService = (data: { content: string }) => {
  return axios({
    method: "PUT",
    url: "/admin/terms-of-service",
    data,
  });
};
